@if (label()) {
  <label class="so-img-input__label">
    {{ label() }}
    @if (effectiveRequired()) {
      <span class="so-img-input__required">*</span>
    }
  </label>
}

<div [ngClass]="containerClasses()">
  <input
    type="file"
    [multiple]="multiple()"
    hidden
    #fileInput
    [disabled]="effectiveDisabled()"
    [id]="idInput()"
    (change)="onFileSelected($event)"
    [accept]="acceptString()">

  @if (showPreview() && hasImages()) {
    <div 
      class="so-img-input__preview-container"
      [ngStyle]="gridStyle()">
      @for (image of images(); track trackByImage($index, image)) {
        <div class="so-img-input__preview-item" [ngStyle]="previewStyle()">
          <img 
            [src]="image.preview" 
            [alt]="image.name"
            class="so-img-input__image">
          <div class="so-img-input__overlay">
            <button 
              type="button"
              class="so-img-input__remove-btn"
              (click)="removeImage($index); $event.stopPropagation()"
              [disabled]="effectiveDisabled()">
              <span class="material-icons">delete</span>
            </button>
          </div>
          <div class="so-img-input__file-info">
            <span class="so-img-input__file-name" [title]="image.name">
              {{ image.name }}
            </span>
            <span class="so-img-input__file-size">
              {{ formatFileSize(image.size) }}
            </span>
          </div>
        </div>
      }
      
      @if (multiple() && canAddMore()) {
        <div 
          class="so-img-input__add-more"
          [ngStyle]="previewStyle()"
          (click)="onZoneClick()"
          (dragover)="onDragOver($event)"
          (dragleave)="onDragLeave($event)"
          (drop)="onDrop($event)">
          <span class="material-icons">add_photo_alternate</span>
          <span>Agregar</span>
        </div>
      }
    </div>
  }

  @if (!hasImages()) {
    <div 
      class="so-img-input__dropzone"
      (click)="onZoneClick()"
      (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave($event)"
      (drop)="onDrop($event)">
      <span class="so-img-input__icon material-icons">add_photo_alternate</span>
      <p class="so-img-input__placeholder">{{ placeholder() }}</p>
      <span class="so-img-input__hint">
        Formatos: JPG, PNG, GIF, WebP • Máx: {{ maxSize() }} MB
      </span>
    </div>
  }

  @if (hasImages() && !multiple()) {
    <div 
      class="so-img-input__single-preview"
      [ngStyle]="previewStyle()"
      (click)="onZoneClick()"
      (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave($event)"
      (drop)="onDrop($event)">
      <img 
        [src]="images()[0].preview" 
        [alt]="images()[0].name"
        class="so-img-input__image">
      <div class="so-img-input__overlay so-img-input__overlay--always">
        <button 
          type="button"
          class="so-img-input__action-btn"
          (click)="$event.stopPropagation()">
          <span class="material-icons">edit</span>
        </button>
        <button 
          type="button"
          class="so-img-input__action-btn so-img-input__action-btn--danger"
          (click)="removeImage(0); $event.stopPropagation()"
          [disabled]="effectiveDisabled()">
          <span class="material-icons">delete</span>
        </button>
      </div>
    </div>
  }
</div>
